import type { RelativeFacing } from './api.js';

/**
 * The four sides of a ROBOT, as an aimed Option is turned to cover one.
 *
 * Not the compass. The card is turned on the robot and its side travels
 * with it, so "front" is whichever way the robot happens to be facing.
 */

/**
 * The order the sides are offered in. Front first, since that is where an
 * untouched card points; then round the robot. A list rather than the
 * map's key order, which is not a thing to rely on for a row of buttons.
 */
export const AIM_SIDES: readonly RelativeFacing[] = ['front', 'back', 'left', 'right'];

/**
 * The side spelled out, for a tooltip or a line of the log. Title Case
 * mid-sentence too: it is the name of a side, not a direction of travel.
 *
 * Typed loosely on the way out because the log indexes it with whatever
 * string an event carries. `satisfies` still requires all four here.
 */
export const AIM_LABEL: Record<string, string> = {
  front: 'Front', back: 'Back', left: 'Left', right: 'Right',
} satisfies Record<RelativeFacing, string>;

/** The side as one letter, for a badge too small to hold a word. */
export const AIM_GLYPH: Record<string, string> = {
  front: 'F', back: 'B', left: 'L', right: 'R',
} satisfies Record<RelativeFacing, string>;
